<template>
  <div class="select">
    <div class="curr" @click="optionsShow = !optionsShow">
      <span class="label">{{ $t(currLabel) }}</span>
      <i :class="['iconfont', optionsShow ? 'icon-shangjiantou1' : 'icon-xiajiantou1']"></i>
    </div>
    <div ref="options" :class="['options']">
      <span
        :class="['option', curr === option.value ? 'activated' : '']"
        v-for="option in options"
        :key="option.value"
        @click="setOption(option.value)"
        >{{ $t(option.label) }}
      </span>
    </div>
    <div class="overlay" v-if="optionsShow" @touchstart="optionsShow = false"></div>
  </div>
</template>

<script>
export default {
  name: 'rk-select',
  model: {
    prop: 'curr',
    event: 'change'
  },
  props: {
    curr: {},
    options: {
      type: Array
    }
  },
  data() {
    return {
      optionsShow: false
    }
  },
  computed: {
    currLabel() {
      return this.options.find((item) => item.value === this.curr)?.label
    }
  },
  watch: {
    optionsShow(newVal) {
      if (newVal) {
        this.$refs.options.style.height = this.optionsHeight + 'px'
      } else {
        this.$refs.options.style.height = 0
      }
    },
    options: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.initialOptins()
        })
      }
    }
  },
  methods: {
    setOption(arg) {
      this.$emit('change', arg)
      this.optionsShow = false
    },
    initialOptins() {
      this.optionsHeight = this.$refs.options.offsetHeight
      if (this.optionsHeight) {
        this.$refs.options.style.height = 0
        this.$refs.options.style.top = this.$pxToVW(50)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  position: relative;
  font-size: 12px;
  color: var(--font-color-2);
  .overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 8;
  }
  .curr {
    position: relative;
    top: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    padding: 0 5px;
    border-radius: 4px;
    line-height: 22px;
    .label {
      margin-right: 4px;
    }
    .iconfont {
      font-size: 8px;
    }
  }
  .options {
    padding: 0 5px;
    position: absolute;
    top: -5000px;
    left: 0px;
    right: 0;
    z-index: 10;
    background: var(--bg-color-5);
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    overflow: hidden;
    .option {
      padding: 6px 0;
      &.activated {
        color: var(--main-color-1);
      }
    }
    transition: 0.4s height;
  }
}
</style>
